module.exports = __webpack_public_path__ + "static/media/closeButton.e007ef14.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/closeButton.svg
// module id = 92
// module chunks = 0